import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  InputAdornment,
  Divider,
  Typography,
  Chip,
} from '@mui/material';
import { Search, Clear } from '@mui/icons-material';
import { Iconify } from 'src/components/iconify';
import type { BranchDto } from 'src/api/employee-transfer.api';

// ----------------------------------------------------------------------

interface BranchTransferFilterSectionProps {
  searchName: string;
  onSearchNameChange: (value: string) => void;
  branches: BranchDto[];
  currentBranchId: string;
  currentBranchName: string;
  currentCompanyName?: string;
  onClearFilters: () => void;
  disabled?: boolean;
}

export function BranchTransferFilterSection({
  searchName,
  onSearchNameChange,
  branches,
  currentBranchId,
  currentBranchName,
  currentCompanyName,
  onClearFilters,
  disabled = false,
}: BranchTransferFilterSectionProps) {


  return (
    <Card>
      <CardHeader
        title="Transfer Filtreleri"
        avatar={<Iconify icon="eva:funnel-fill" width={24} height={24} />}
        subheader={
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Mevcut Şube:
            </Typography>
            <Chip 
              label={currentBranchName} 
              color="primary" 
              size="small" 
              variant="outlined"
            />
          </Stack>
        }
      />
      <CardContent>
        <Stack spacing={3}>
          {/* Filter Row 1 */}
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
            {/* Name Search */}
            <TextField
              fullWidth
              label="Çalışan Adı"
              placeholder="İsim veya soyisim ile arama yapın..."
              value={searchName}
              onChange={(e) => onSearchNameChange(e.target.value)}
              disabled={disabled}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ color: 'text.disabled' }} />
                  </InputAdornment>
                ),
              }}
            />
          </Stack>

                     {/* Info Section */}
           <Box sx={{ 
             p: 2, 
             bgcolor: 'background.neutral', 
             borderRadius: 1,
             border: '1px solid',
             borderColor: 'divider'
           }}>
             <Stack direction="row" alignItems="center" spacing={1}>
               <Iconify icon="mdi:information" width={20} height={20} color="info.main" />
               <Typography variant="body2" color="text.secondary">
                 {currentBranchName} şubesinden sadece <strong>{currentCompanyName}</strong> şirketinin diğer şubelerine çalışan transferi yapabilirsiniz.
               </Typography>
             </Stack>
           </Box>

          <Divider />

          {/* Action Buttons */}
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              variant="outlined"
              startIcon={<Clear />}
              onClick={onClearFilters}
              disabled={disabled}
            >
              Filtreleri Temizle
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
